module.exports = __webpack_public_path__ + "images/shimo/sheet-list-0ae297f7ee91309149c19c05a5a218e0.png";